import { withInstall } from '@sgui-plus/utils/with-install'

import Icon from './src/icon.vue'

export const SgIcon = withInstall(Icon)
export default SgIcon

export * from './src/icon'
